import { Component, OnInit, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterOutlet, Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SeoService } from '../core/seo/seo.service';
import { MtrLinkModalComponent } from '../shared/ui/mtr-link-modal/mtr-link-modal.component';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, MtrLinkModalComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'weko-new';
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private seoService = inject(SeoService);
  private platformId = inject(PLATFORM_ID);

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.documentElement.classList.remove('weko-auth-loading');
      document.documentElement.classList.remove('weko-route-loading');

      // Global fix: Prevent mouse-wheel / trackpad scrolling from incrementing/decrementing input[type="number"] values
      window.addEventListener(
        'wheel',
        (event: WheelEvent) => {
          const target = event.target as HTMLElement;
          if (target && target.tagName === 'INPUT' && (target as HTMLInputElement).type === 'number') {
            if (document.activeElement === target) {
              (target as HTMLInputElement).blur();
            }
          }
        },
        { passive: true }
      );
    }

    // Initial SEO update for SSR / first render
    this.updateSeoForCurrentRoute();

    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.updateSeoForCurrentRoute();

      // SPA route change tracking for Google Ads and GA4
      if (isPlatformBrowser(this.platformId) && typeof gtag === 'function') {
        gtag('config', 'AW-18420157571', { page_path: event.urlAfterRedirects });
        gtag('config', 'G-7TFFX3BHJY', { page_path: event.urlAfterRedirects });
      }
    });
  }

  private updateSeoForCurrentRoute(): void {
    let route = this.activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }

    const seoData = route.snapshot.data['seo'];
    const currentPath = this.router.url.split('?')[0].split('#')[0];

    if (seoData) {
      this.seoService.generateTags({
        title: seoData.title,
        description: seoData.description,
        keywords: seoData.keywords,
        robots: seoData.robots,
        url: currentPath
      });
    } else {
      const isPrivateOrAuth = currentPath.startsWith('/auth') || currentPath.startsWith('/client') || currentPath.startsWith('/trader');
      this.seoService.generateTags({
        title: 'WEKO | Trade like a PRO with All-in-One Platform',
        description: 'Trade with Multiple Crypto, Forex and Commodity. WEKO is a place where Traders and Investors meet.',
        robots: isPrivateOrAuth ? 'noindex, follow' : 'index, follow',
        url: currentPath
      });
    }
  }
}
